import type {BulkUpdate} from 'api/types';
import type {Collection} from 'services/series/types';
import {formatDateNo} from 'localization/core/formatting/formatDateNo';
import type {Schemas} from 'api/dto.generated';
import {mapBulkUpdateFieldAndAction} from './mapBulkUpdateFieldAndAction';

export const mapBulkUpdateDto = (
  id: string,
  dto: Schemas.BulkUpdateStatusResponse,
  collections?: Collection[],
): BulkUpdate => {
  return {
    id: id,
    status: dto.status,
    items: dto.items,
    ...mapBulkUpdateFieldAndAction(dto.field, dto.action, collections),
    created: formatDateTime(dto.created),
    completed: dto.completed ? formatDateTime(dto.completed) : undefined,
  };
};
const formatDateTime = (timestamp: number): string => {
  return formatDateNo(timestamp * 1000, 'short', true);
};
